var _excluded = ["listingType", "hero", "onOptionChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import ListingType from '@domain-group/fe-allhomes-library/lib/enums/listing-type';
import { TabBar } from '@domain-group/fe-co-allhomes-tabbed-panel';
import SearchPanel from './search-panel';
import CommonPropTypes from '../../models/common-prop-types';
import ContainerPropTypes from '../../models/container-prop-types';
import { optionsForListingType } from '../../models/search-options';
import { Hero } from '../hero';
import * as styles from './mobile.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var MobileContainer = _ref => {
  var listingType = _ref.listingType,
    hero = _ref.hero,
    onOptionChange = _ref.onOptionChange,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var options = optionsForListingType(listingType);
  var tabs = options.map(option => ({
    id: option.value,
    label: option.label.toUpperCase(),
    className: 'listing-type-tab'
  }));
  var activePanelIndex = tabs.findIndex(tab => tab.id === listingType);
  return ___EmotionJSX("div", {
    css: styles.container
  }, ___EmotionJSX(Hero, hero), ___EmotionJSX("div", {
    css: styles.searchContainer
  }, ___EmotionJSX(TabBar, {
    alignment: "centre",
    tabWrapper: ___EmotionJSX("div", {
      css: styles.tabWrapper
    }),
    activeIndex: activePanelIndex,
    tabs: tabs,
    onClick: (index, tab) => {
      if ("".concat(tab.id) !== tabs[activePanelIndex].id) {
        if (onOptionChange) {
          onOptionChange(tab.id);
        }
        window.location.href = "/".concat(ListingType[tab.id].urlContext, "/");
      }
    }
  })), ___EmotionJSX(SearchPanel, _extends({}, otherProps, {
    listingType: listingType
  })));
};
export var propTypes = _objectSpread(_objectSpread(_objectSpread({}, CommonPropTypes), ContainerPropTypes), {}, {
  hero: PropTypes.shape()
});
MobileContainer.propTypes = propTypes;
MobileContainer.defaultProps = {
  hero: undefined
};
export default MobileContainer;